// extracted by mini-css-extract-plugin
export var arrow = "bl_dG";
export var profile = "bl_dF";
export var text = "bl_dw";